import api from 'api';
import ApiService from 'api/ApiService';
import Token from 'api/Token';
import {XCSRF_TOKEN_HEADER} from 'common/constants';

let csrfRefreshPromise: Promise<string> | null = null;

const fetchCsrfToken = (url: string = api.connect) => {
   return ApiService.getOrigin(url, {[XCSRF_TOKEN_HEADER]: 'Fetch'})
      .then((res) => {
         console.debug('fetchCsrfToken got result:', res, res.headers?.get(XCSRF_TOKEN_HEADER));
         const csrfToken = res.headers?.get(XCSRF_TOKEN_HEADER);
         console.debug('csrf token:', csrfToken);
         return csrfToken;
      })
      .catch((res) => {
         console.debug(
            'fetchCsrfToken got error result:',
            res,
            res.headers?.get(XCSRF_TOKEN_HEADER)
         );
         const csrfToken = res.headers?.get(XCSRF_TOKEN_HEADER);
         console.debug('csrf token:', csrfToken);
         return csrfToken;
      });
};

export const refreshCsrfOnce = (): Promise<string> => {
   console.debug('refreshCsrfOnce called with refresh promise:', csrfRefreshPromise);
   if (!csrfRefreshPromise) {
      csrfRefreshPromise = fetchCsrfToken()
         .then((token) => {
            console.debug('refreshCsrfOnce got token:', token);
            Token.setCsrfToken(token);
            return token;
         })
         .finally(() => {
            csrfRefreshPromise = null;
         });
   }

   return csrfRefreshPromise;
};
